import { useState } from "react";
import { SelectProps, Select as SelectRAC } from "react-aria-components";
import { AnimationDefinition } from "framer-motion";
import { AnimationState, SelectTriggerContext } from "./types";

export default function SelectTrigger<T extends object>(props: SelectProps<T>) {
  const [currentAnimation, setAnimation] =
    useState<AnimationState>("unmounted");

  const onComplete = (animation: AnimationDefinition) => {
    setAnimation((prevAnimation) =>
      animation === "hidden" && prevAnimation === "hidden"
        ? "unmounted"
        : prevAnimation,
    );
  };

  return (
    <SelectTriggerContext.Provider
      value={{
        currentAnimation,
        onComplete,
      }}
    >
      <SelectRAC
        {...props}
        onOpenChange={(isOpen) => {
          setAnimation(isOpen ? "visible" : "hidden");
          props.onOpenChange?.(isOpen);
        }}
      />
    </SelectTriggerContext.Provider>
  );
}
